import {
  fetchGuideComplete,
  fetchGuideStepCreate,
  useGuideCreateMutation,
} from '@blesk-frontend/api';
import {Page} from '@blesk-frontend/ui';
import {toast} from 'sonner';

import {GuideForm, GuideFormData} from '@/features/guides';
import {Route} from '@/routes/_app/guides/create';

export const GuideCreatePage = () => {
  const navigate = Route.useNavigate();
  const {mutateAsync: guideCreateMutateAsync} = useGuideCreateMutation();

  const onSubmit = async (data: GuideFormData) => {
    try {
      const guide = await guideCreateMutateAsync(data);

      await Promise.all(
        data.steps.map((step) => {
          return fetchGuideStepCreate(guide.id, step);
        }),
      );

      await fetchGuideComplete(guide.id);
      await navigate({to: '/guides/$guideId', params: {guideId: guide.id}, search: {new: true}});
    } catch (_err) {
      toast.error('Произошла ошибка при создании инструкции');
    }
  };

  return (
    <Page>
      <GuideForm guide={undefined} onSubmit={onSubmit} />
    </Page>
  );
};
